import focus from "./focus";
const install = function(Vue) {
  Vue.directive("focus", focus); //v-focus
};

if (window.Vue) {
  window["focus"] = focus;
  Vue.use(install); // eslint-disable-line
}

export default install;



// WEBPACK FOOTER //
// ./src/plugins/directive/index.js